import { render, staticRenderFns } from "./ProfitPercentageTooltip.vue?vue&type=template&id=4523c65b"
import script from "./ProfitPercentageTooltip.vue?vue&type=script&lang=js"
export * from "./ProfitPercentageTooltip.vue?vue&type=script&lang=js"
import style0 from "./ProfitPercentageTooltip.vue?vue&type=style&index=0&id=4523c65b&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4523c65b')) {
      api.createRecord('4523c65b', component.options)
    } else {
      api.reload('4523c65b', component.options)
    }
    module.hot.accept("./ProfitPercentageTooltip.vue?vue&type=template&id=4523c65b", function () {
      api.rerender('4523c65b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProfitPercentageTooltip.vue"
export default component.exports